import { useState, useEffect } from "react";
import { Typography, Row, Col, Input, Select, Alert } from "antd";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const EditPosition = ({ id }) => {
  const { MainResponse } = useSelector((state) => state);
  const navigate = useNavigate();

  const [oldPositionName, setOldPositionName] = useState("");
  const [positionName, setPositionName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [departmentName, setDepartmentName] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);

  useEffect(() => {
    getAPosition();
  }, []);

  const getAPosition = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-position/${id}`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    if (result) {
      setOldPositionName(result.positionName);
      setPositionName(result.positionName);
      setCompanyName(result.companyName);
      setDepartmentName(result.departmentName);
    }
  };

  const handleChangeCompany = (value) => {
    setCompanyName(value);
  };

  const handleChangeDepartment = (value) => {
    setDepartmentName(value);
  };

  const updatePosition = async () => {
    if (positionName && departmentName && companyName) {
      setButtonDisable(true);

      let result = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/position-update/${id}`,
        {
          method: "put",
          body: JSON.stringify({
            oldPositionName,
            positionName,
            companyName,
            departmentName,
          }),
          headers: {
            "Content-Type": "application/json",
            authorization: `bearer ${JSON.parse(
              localStorage.getItem("token")
            )} `,
          },
        }
      );
      result = await result.json();
      if (result) {
        setButtonDisable(false);

        navigate(-1);
      }
    } else {
      setShowAlert(true);
    }
  };

  return (
    <>
      {showAlert && (
        <Alert
          onClose={() => setShowAlert(false)}
          message="Diqqət!"
          description="Zəhmət olmasa boş sahələri doldurun!"
          type="warning"
          showIcon
          closable
        />
      )}
      <Row className="add-row">
        <Col span={6}>
          <Typography.Text className="add-title">Vəzifənin adı</Typography.Text>
          <Input
            className="add-input"
            size="large"
            value={positionName}
            onChange={(e) => setPositionName(e.target.value)}
          />
        </Col>
        <Col span={6}>
          <Typography.Text className="add-title">Şirkət</Typography.Text>

          <Select
            size="large"
            className="add-dropdown"
            value={companyName}
            onChange={handleChangeCompany}
            options={MainResponse.allCompanyNames}
          />
        </Col>
        <Col span={6}>
          <Typography.Text className="add-title">Şöbə</Typography.Text>

          <Select
            size="large"
            className="add-dropdown"
            value={departmentName}
            onChange={handleChangeDepartment}
            options={MainResponse.allDepartmentNames}
          />
        </Col>
        <Col span={3}>
          <button
            disabled={buttonDisable}
            className="success-button"
            onClick={updatePosition}
          >
            Təsdiq Et
          </button>
        </Col>
        <Col span={3}>
          <button
            className="cancel-button"
            onClick={() => {
              navigate(-1);
            }}
          >
            İmtina Et
          </button>
        </Col>
      </Row>
    </>
  );
};

export default EditPosition;
